
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useEffect, useState,useRef } from 'react';
import RawMaterialService, { GetRemainingMFPOS } from "../../services/RawMaterials/RawMaterialService";
import { Toast } from "primereact/toast";
import posService from '../../services/pos/pos.service';

interface RequestRawMaterialProps {
  visible: boolean;
  onHide: () => void;
  rawmaterial: any;
  setLoading: (loading: boolean) => void;
}

const RequestRawMaterial: React.FC<RequestRawMaterialProps> = ({ visible, onHide, rawmaterial,setLoading }) => {
  const toast = useRef<Toast>(null);
  const [quantity, setQuantity] = useState<number>(0);
  const [otherPOSStock, setOtherPOSStock] = useState<any[]>([]);
  const [selectedPOS, setSelectedPOS] = useState<any>(null);
  const [vendorOptions, setVendorOptions] = useState<any[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<number | null>(null);
  const [invoiceOptions, setInvoiceOptions] = useState<any[]>([]);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
  const [loadingLocal, setLoadingLocal] = useState(false);

useEffect(() => {
  if (selectedPOS) {
    const loadVendors = async () => {
      try {
        const data = {
          rawMaterialId: rawmaterial.rawMaterialId,
          posId: selectedPOS.posID,
        };
        const vendors = await RawMaterialService.GetVendorandInvoiceWiseQty(data);
        setVendorOptions(Array.isArray(vendors) ? vendors : []);
        setSelectedVendor(null);  // reset selection
        setSelectedInvoice(null); // reset selection
        setInvoiceOptions([]);
      } catch (error) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Could not load vendors",
        });
      }
    };

    loadVendors();
  }
}, [selectedPOS]);

useEffect(() => {
  if (selectedVendor) {
    const vendor = vendorOptions.find(v => v.vendorId === selectedVendor);
    setInvoiceOptions(vendor?.invoices || []);
  } else {
    setInvoiceOptions([]);
    setSelectedInvoice(null);
  }
}, [selectedVendor]);

  useEffect(() => {
    if (visible && rawmaterial) {
      GetRemainingMFPOS(rawmaterial.posId).then((response) => {
        if (response) {
          setOtherPOSStock(response);
        }
      });
    }
  }, [visible, rawmaterial]);

  useEffect(() => {
  if (!visible) {
    setQuantity(0);
    setSelectedPOS(null);
     setSelectedVendor(null);
     setSelectedInvoice(null);
     setVendorOptions([]);
     setInvoiceOptions([]);
  }
}, [visible]);

  const handleSubmit = async () => {
    if (!quantity || quantity <= 0) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please enter a quantity.",
    });
    return;
  }

  if (!selectedPOS) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please select a POS.",
    });
    return;
  }

  if (rawmaterial.measurementTypeId === 4 && !Number.isInteger(quantity)) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Decimal quantities are not allowed for this product.",
    });
    return;
  }

  if (!selectedInvoice) {
  toast.current?.show({
    severity: "warn",
    summary: "Validation Error",
    detail: "Please select an invoice.",
  });
  return;
}

if (quantity > selectedInvoice.quantity) {
  toast.current?.show({
    severity: "warn",
    summary: "Validation Error",
    detail: `Requested quantity (${quantity}) exceeds available invoice quantity (${selectedInvoice.quantity}).`,
  });
  return;
}


 const requestPayload = {
    rawMaterialId: rawmaterial.rawMaterialId,
    requestFromPOS: rawmaterial.posId,
    requestToPOS: selectedPOS.posID,
    quantity: quantity,
    VendorID: selectedVendor,
    InvoiceNumber: selectedInvoice.invoiceNumber,
    RawMaterialPurchaseId: selectedInvoice?.rawMaterialPurchaseId
  };

  try {
    setLoading(true);
      setLoadingLocal(true);
    const response = await RawMaterialService.AddRawMaterialRequest(requestPayload);
    if (response?.isSuccess) {
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: response.message || "Product request sent successfully",
      });
      onHide();
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: response?.message || "Failed to submit product request",
      });
    }
  } catch (error) {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "An error occurred while submitting the request",
    });
    console.error('Error submitting request', error);

  }finally {
    setLoading(false); // Always stop loading
    setLoadingLocal(false);
  }
  };

 return (
  <>
  <Toast ref={toast} />
  <Dialog header="Request Product" visible={visible} style={{ width: '35vw' }} onHide={onHide} className="p-fluid">
    <div className="p-3">
      <div className="mb-3">
        <label className="font-semibold text-sm block mb-1">Product</label>
        <div className="p-inputtext p-component bg-gray-100 py-2 px-3 rounded">
          {rawmaterial?.rawMaterialName || '-'}
        </div>
      </div>

      <div className="mb-3">
        <label className="font-semibold text-sm block mb-1">Request Quantity</label>
        <InputText
          type="number"
          min="0"
          keyfilter="pnum"
          // value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          placeholder="Enter quantity"
          style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
        />
      </div>

      <div className="mb-3">
        <label className="font-semibold text-sm block mb-1">Select POS to Request From</label>
                <Dropdown
            value={selectedPOS}
            options={otherPOSStock}
            optionLabel="posCode"
            onChange={(e) => setSelectedPOS(e.value)}
            placeholder="Select POS"
            className="w-full"
            style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
            />
            
      </div>

      <div className="mb-3">
  <label className="font-semibold text-sm block mb-1">Vendor</label>
  <Dropdown
    value={selectedVendor}
    options={vendorOptions}
    optionLabel="vendorName"
    optionValue="vendorId"
    onChange={(e) => setSelectedVendor(e.value)}
    placeholder="Select Vendor"
    style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
    itemTemplate={(option) => (
      <div>
        {option.vendorName}
        <span className="ml-2 text-color-secondary text-sm">(Avail. Qty: {option.totalQuantity})</span>
      </div>
    )}
    valueTemplate={(option) =>
      option ? `${option.vendorName} (Avail. Qty: ${option.totalQuantity})` : "Select Vendor"
    }
    className="w-full"
  />
</div>

{/* Invoice Dropdown */}
{selectedVendor && (
  <div className="mb-3">
    <label className="font-semibold text-sm block mb-1">Invoice Number</label>
    <Dropdown
      value={selectedInvoice?.invoiceNumber || null}
      options={invoiceOptions}
      optionLabel="invoiceNumber"
      optionValue="invoiceNumber"
      onChange={(e) => {
        const selected = invoiceOptions.find(inv => inv.invoiceNumber === e.value);
        setSelectedInvoice(selected);
      }}
      placeholder="Select Invoice"
      itemTemplate={(option) => (
        <div>
          {option.invoiceNumber} - {option.quantity}
        </div>
      )}
      valueTemplate={(option) =>
        option ? `${option.invoiceNumber} - ${option.quantity}` : "Select Invoice"
      }
      className="w-full"
    />
  </div>
)}

      <div className="flex justify-end pt-2">
        <Button label="Submit Request" icon="pi pi-check" onClick={handleSubmit} loading={loadingLocal} disabled={loadingLocal}/>
      </div>
    </div>
  </Dialog>
  </>
);
};

export default RequestRawMaterial;
